import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Card } from '../../../../shared/components/card/card';
import { ICardInfoData } from '../../../../shared/interfaces/card-info.interface';

@Component({
  selector: 'app-marketing-card-container',
  imports: [CommonModule, Card],
  templateUrl: './marketing-card-container.html',
  styleUrl: './marketing-card-container.scss'
})
export class MarketingCardContainer {
  @Input() cardInfo: ICardInfoData[] = []
}
